import { useEffect } from 'react';
import { useHeader } from '../../Providers/HeaderContextProvider';
import arisLogo from '../../Assets/icon/aris_logo.svg';
import uatQRCode from '../../Assets/icon/uat-aris-app-code.png';
import '../Login/AuthPages.css';

const OnboardingQRPage = () => {
  const { setHeaderContent } = useHeader();

  useEffect(() => {
    // Show header so user can access logout
    setHeaderContent(true);
  }, [setHeaderContent]);

  const getQRCodeImage = () => {
    // Check if we're in production environment
    const isProduction = process.env.REACT_APP_ENV === 'production' || 
                        process.env.NODE_ENV === 'production';
    
    // For production, use environment variable or fallback to API-generated QR
    if (isProduction && process.env.REACT_APP_PROD_QR_CODE) {
      return process.env.REACT_APP_PROD_QR_CODE;
    }
    
    // For UAT/development, use local QR code image
    return uatQRCode;
  };

  return (
    <div className="auth-page-container">
      <div className="auth-page-content qr-page-content">
        <img src={arisLogo} alt="Aris" className="auth-page-logo" />
        
        <h2 className="qr-page-title">Continue on your phone</h2>
        <p className="qr-page-subtitle">
          Aris begins with a short exercise in the mobile app.<br />
          Complete it once, and you'll have full access here on the web.
        </p>

        <div className="qr-code-container">
          <img 
            src={getQRCodeImage()} 
            alt="QR Code" 
            className="qr-code-image"
          />
        </div>

        <p className="qr-scan-instruction">
          Scan with your phone to open the Aris app and continue
        </p>

        <p className="auth-page-footer">© 2026 Aristotle, Inc. All rights reserved. Patents pending.</p>
      </div>
    </div>
  );
};

export default OnboardingQRPage;
